import { InitialUserInfo } from "../../interfaces";
import { SET_MANAGER_EMAIL, SET_MANAGER_EMAIL_REQUIRED, SET_PUBLIC_KEY, SET_USER_AUTHENTICATED,SET_USER_AUTHENTICATION_FAIL_REASON, SET_RENEWAL_INTERCEPT_REQUIRED, SET_NEWSFEED_COUNTRY_BLOCK, GET_PRODUCT_ID, GET_BADGE_URL, GET_IS_TMS_REQUIRED, SET_SELECTED_COUNTRY, SET_SELECTED_LANGUAGE} from "./../constants";

const setUserInitialInformation = (lgId: string | number, luuId: string | number, leuId: string | number) => {
  return (dispatch: any) => {
    dispatch({
      type: "SET_INITIAL_USER_INFO",
      payload: {
        lgId,
        luuId,
        leuId,
      },
    });
  };
};

const setUserInitialInformationPeople = (userInfo: InitialUserInfo) => {
  const { firstName, lastName, userId } = userInfo;
  return (dispatch: any) => {
    dispatch({
      type: "SET_INITIAL_USER_INFO",
      payload: {
        firstName,
        lastName,
        userId,
      },
    });
  };
};

const setPublicKey = (userInfo: InitialUserInfo) => {
  const { pub } = userInfo;
  return (dispatch: any) => {
    dispatch({
      type: SET_PUBLIC_KEY,
      payload: {
        pub,
      },
    });
  };
};

const setLanguage = (language: string) => {
  return (dispatch: any) => {
    dispatch({
      type: SET_SELECTED_LANGUAGE,
      payload: {
        language
      },
    });
  };
};

const setManagerEmail = (email: string) => {
  const managerEmail  = email;
  return (dispatch: any) => {
    dispatch({
      type: SET_MANAGER_EMAIL,
      payload: {
        managerEmail,
      },
    });
  };
};

const setIsNewsfeedTzBlocked = (isBlocked: boolean) => {
  return (dispatch: any) => {
    dispatch({
      type: SET_NEWSFEED_COUNTRY_BLOCK,
      payload: {
        isBlocked,
      },
    });
  };
};

const setProductID = (productId: string) => {
  const productID  = productId;
  return (dispatch: any) => {
    dispatch({
      type: GET_PRODUCT_ID,
      payload: {
        productID,
      },
    });
  };
};

const setManagerEmailRequired = (isManagerEmail : Boolean) => {
  const  isManagerEmailRequired =  isManagerEmail;
  return (dispatch: any) => {
    dispatch({
      type: SET_MANAGER_EMAIL_REQUIRED,
      payload: {
        isManagerEmailRequired,
      },
    });
  };
};
const setUserAuthenticated = (isUserAuthenticated: boolean) => {
  return (dispatch: any) => {
    dispatch({
      type: SET_USER_AUTHENTICATED,
      payload: {
        isUserAuthenticated,
      },
    });
  };
}
const setUserAuthenticationFailReason = (userAuthenticationFailReason: string) => {
  return (dispatch: any) => {
    dispatch({
      type: SET_USER_AUTHENTICATION_FAIL_REASON,
      payload: {
        userAuthenticationFailReason,
      },
    });
  };
}
const setRenewalInterceptRequired = (isRenewalRequired : boolean) => {
  const  isRenewalInterceptRequired  = isRenewalRequired;
  return (dispatch: any) => {
    dispatch({
      type: SET_RENEWAL_INTERCEPT_REQUIRED,
      payload: {
        isRenewalInterceptRequired,
      },
    });
  };
};

const setBadgeURL = (badgeURL : string) => {
  const  getBadgeURL  = badgeURL;
  return (dispatch: any) => {
    dispatch({
      type: GET_BADGE_URL,
      payload: {
        getBadgeURL,
      },
    });
  };
};

const setIsTMSRequired = (isTMSCallRequired : boolean) => {
  return (dispatch: any) => {
    dispatch({
      type: GET_IS_TMS_REQUIRED,
      payload: {
        isTMSCallRequired,
      },
    });
  };
};

const setSelectedCountry = (selectedCountry : string) => {
  return (dispatch: any) => {
    dispatch({
      type: SET_SELECTED_COUNTRY,
      payload: {
        selectedCountry,
      },
    });
  };
};

export default {
  setUserInitialInformation,
  setUserInitialInformationPeople,
  setPublicKey,
  setLanguage,
  setManagerEmail,
  setManagerEmailRequired,
  setUserAuthenticated,
  setUserAuthenticationFailReason,
  setRenewalInterceptRequired,
  setProductID,
  setBadgeURL,
  setIsNewsfeedTzBlocked,
  setIsTMSRequired,
  setSelectedCountry
};
